<template>
  <div class="temp-wrap">
    <img :src="`${envConst.SCMCC_HOST}/images/${path}.png`" />
    <p class="service-title">{{text}}</p>
    <p v-if="path == 'pic_call' ? true : false" class="tip-title">您还没有开通呼叫中心功能，分钟级开通，更多号码资源，更低资费，稳定安全</p>
    <p v-if="path == 'pic_online_service'" class="tip-title">您还没有开通在线客服功能，分钟级开通，更多号码资源，更低资费，稳定安全</p>
    <p v-if="path == 'pic_lost_connection'" class="tip-title">您还没有开通金融大数据功能</p>
    <p class="tip-title" style="margin-top:12px;">
      申请开通请咨询
      <span @click="goToServe" class="servive-blue-text">在线客服</span>
      或致电400-139-0322
    </p>
  </div>
</template>
<script>
import envConst from '../env-const.js'
export default {
  name: 'defaultMenu',
  props:["path","text"],
  data: () => ({
    envConst,
    webchatUrl: {
      css: "/static/css/webchat-main-1.0.0.css",
      lte_ie8: "/lte-ie8-1.0.0.js",
      config: "/easemob/webim.config.js",
      strophe: "/easemob/strophe-1.2.8.min.js",
      websdk: "/easemob/websdk-1.4.13.js",
      main: "/static/js/webchat-main-1.0.0.js"
    }
  }),
  mounted(){
    //加载在线客服资源
    this.loadHead(this.webchatUrl.css)
    this.loadHeadJs(this.webchatUrl.lte_ie8)
    this.loadBody(this.webchatUrl.config)
    this.loadBody(this.webchatUrl.strophe)
    this.loadBody(this.webchatUrl.websdk)
    this.loadBody(this.webchatUrl.main)
    setTimeout(() => {
      this.initWebChat()
    }, 1000);
  },
  methods:{
    loadHead(url) {
      const link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = envConst.WEBCHAT_HOST + url;
      document.head.appendChild(link);
    },
    loadHeadJs(url) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = envConst.WEBCHAT_HOST + url;
      document.head.appendChild(s);
    },
    loadBody(url) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = envConst.WEBCHAT_HOST + url;
      document.body.appendChild(s);
    },
    initWebChat() {
      webChat.init(
        {
          appKey: 'zyzxwz_webchat#ZB29893103663',
          companyId: 'zyzxwz_webchat',
          provinceCode: '001',
          deviceNo: 'cmsc',
          nickname: JSON.parse(localStorage.getItem('user')).info.tenantName
        }, 
        () => {
          console.log('>>>>>>>>>>>>>>webchat初始化成功>>>>>>>>>>>>>>>');
        }, 
        () => {
          console.log('>>>>>>>>>>>>>>webchat初始化失败>>>>>>>>>>>>>>>');
        }
      )
    },
    goToServe() {
      this.$nextTick(()=>{
        webChat.panelControl(true)
      })
    }
  }
}
</script>
<style>
.temp-wrap{
    height: 800px;
    border-radius: 6px;
    box-shadow: 0 2px 8px 0 #dae1f4;
    border: 1px solid #dae1f4;
    background: #fff;
    text-align: center;
    padding-top: 99px;
}
.temp-wrap p{
    color: #5e5f77;
    font-weight: bold;
}
.service-title{
    font-size: 30px;
    margin-bottom: 24px;
}
.tip-title{
    font-size: 18px;
}
.servive-blue-text{
    color: #04CBD8;
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
}
</style>